import { AppTableInitialState } from 'components/AppTable/store';

export const SORT_KEY_MAP: Record<string, string> = {
  source_title: 'title',
  user_name: 'user',
  customer_abbreviation: 'customer_name',
};

const toCsv = (filter: any): string[] => {
  if (Array.isArray(filter)) {
    return filter.map((x) => x?.value).filter(Boolean);
  }

  if (filter?.value !== undefined && filter?.value !== null) {
    return [filter.value];
  }

  return [];
};

export const toTimeEntriesParams = (
  params: Record<string, any>,
  state: AppTableInitialState,
): Record<string, any> => {
  const filters = state.params.filters ?? {};
  const next: Record<string, any> = { ...params };

  Object.keys(next).forEach((key) => {
    if (key.startsWith('filters[')) {
      delete next[key];
    }
  });

  const sortBy = params['sort[by]'] as string | undefined;
  if (sortBy) {
    const column = SORT_KEY_MAP[sortBy] ?? sortBy;
    const prefix = params['sort[direction]'] === 'asc' ? '' : '-';
    next.sort = `${prefix}${column}`;
  }
  delete next['sort[by]'];
  delete next['sort[direction]'];

  const from = filters.date_start?.value;
  const to = filters.date_end?.value;
  if (from && to) {
    next['filter[between_dates]'] = `${from},${to}`;
  }

  const assignCsv = (target: string, filterKey: string) => {
    const values = toCsv(filters[filterKey]);
    if (values.length) {
      next[target] = values.join(',');
    }
  };

  assignCsv('filter[source]', 'source');
  assignCsv('filter[plan]', 'project_plan');
  assignCsv('filter[user_type]', 'user_type');
  assignCsv('filter[project]', 'project_uuid');
  assignCsv('filter[request]', 'request_uuid');

  const users = toCsv(filters.user_uuid).filter((value) => value !== 'all');
  if (users.length) {
    next['filter[user]'] = users.join(',');
  }

  const categories = toCsv(filters.category);
  const hasBillable = categories.includes('billable');
  const hasNonBillable = categories.includes('non-billable') || categories.includes('sgm-non-billable');
  if (hasBillable && !hasNonBillable) {
    next['filter[billable]'] = true;
  } else if (!hasBillable && hasNonBillable) {
    next['filter[billable]'] = false;
  }

  if (filters.missed_only) {
    next['filter[late_only]'] = true;
  }

  const [manual] = toCsv(filters.is_manual);
  if (manual !== undefined) {
    next['filter[is_manual]'] = manual;
  }

  return next;
};
